"use client";

import { useState } from "react";
import { Edit3 } from "lucide-react";
import EditBusinessModal from "./EditBusinessModal";

export default function EditBusinessButton({
  businessid,
  handleFormSubmit,
  isLoading,
  handleBusinessOfferSubmit,
  handleBusinessCatalogSubmit,
  handleDetailsSubmit


}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className="bg-[#7b189f] hover:bg-[#7b189f]/90 text-white px-4 py-2 rounded-md text-sm font-medium flex items-center gap-2 transition-colors"
      >
        <Edit3 className="h-4 w-4" />
        Edit Business
      </button>

      <EditBusinessModal
        open={isModalOpen}
        setOpen={setIsModalOpen}
        businessId={businessid}
        handleFormSubmit={handleFormSubmit}
        isLoading={isLoading}
        handleBusinessOfferSubmit={handleBusinessOfferSubmit}
        handleBusinessCatalogSubmit={handleBusinessCatalogSubmit}
        handleDetailsSubmit={handleDetailsSubmit}


      />
    </>
  );
}
